import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Routes, Route, BrowserRouter, Outlet } from "react-router-dom";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./style/pfapp.scss";

import Login from "pages/Login";
import NotValidTab from "pages/NotValidTab";
import { PrivateRoute } from "routes/privateRoute";
import axios from "axios";
import { ModuleAccess } from "utils/moduleaccess";
import Dashboard from "pages/Dashboard";
import OrderEntry from "pages/OrderEntry";
import Claims from "pages/Claims";
import Packaging from "pages/Packaging";
import Pending from "pages/Pending";
import FinalReview from "pages/FinalReview";
import CreateNewRx from "pages/OrderEntry/CreateNewRx";
// import ChangePatients from "pages/OrderEntry/ChangePatients";
import PatientDetails from "pages/OrderEntry/PatientsDetails";
import InitialReviewPatientDetails from "pages/InitialReview/InitialReviewPatientDetails";
import InitialReviewPage from "pages/InitialReview/InitialReviewPage";
import InitialPatientEditDetails from "pages/InitialReview/InitialPatientEditDetails";
import FinalReviewPage from "pages/FinalReview/FinalReviewPage";
import FinalReviewDetailsPage from "../src/pages/FinalReview/FinalReviewDetialsPage";
import PackagingInfoDetails from "pages/Packaging/PackagingInfoDetails";
import InvDashboard from "pages/Inventory/InvDashboard";
import InvOptimization from "pages/Inventory/InvOptimizations";
import Products from "pages/Inventory/Products";
import CycleCount from "pages/Inventory/CycleCount";
import PurchaseOrders from "pages/Inventory/PurchaseOrders";
import OnOrderQueueDetails from "pages/Inventory/PurchaseOrders/OnOrder/OnOrderQueueDetails";
import OrdersDetails from "pages/Inventory/PurchaseOrders/OrderHistory/OrdersDetials";
import ReceiveOrderQueue from "pages/Inventory/PurchaseOrders/ReceiveOrders/ReceiveOrderQueue";
import ReceiveOrderDetails from "pages/Inventory/PurchaseOrders/ReceiveOrders/ReceiveOrderDetails";
import Patients from "pages/Patients";
import ReportsDashboard from "pages/Reports/Dashboard";
import ReportsSchduler from "pages/Reports/Schduler";
import AddNewPatient from "pages/OrderEntry/CreateNewRx/AddNewPatient";
import Builder from "pages/Reports/Builder";
import EntryNewRxSearchPatient from "pages/OrderEntry/CreateNewRx/EntryNewRxSearchPatients";
import AddNewRxSearchPatient from "pages/OrderEntry/CreateNewRx/EntryNewRxSearchPatients/AddNewRxSearchPatient";
import PatientsPage from "pages/Patients";
import PatientInformation from "pages/Patients/PatientsPage";
const App = () => {
  const [modules, setModules] = useState([]);

  const fetchModules = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub } = profile || {};
    try {
      if (access_token) {
        renderPurchaseOrder();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const ThemeSelector = async () => {
    const { token_type, access_token, profile } =
      JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
    const { sub } = profile || {};
    try {
      import("./style/pfapp.scss");
    } catch (error) {
      console.log(error.message);
    }
    return <></>;
  };
  const dashboard = () => {
    return <Route path="/workflow-dashboard" element={<Dashboard />} />;
    //let module = modules.filter(m => m.code == "PRD")
    // if (ModuleAccess("PRD", ''))
    //   return (<Route path='/providers' element={<Providers module={module[0]} />} />)
  };

  const renderLogin = () => {
    return <Route index element={<Login />} />;
  };
  const orderEntry = () => {
    return <Route path="/workflow-orderEntry" element={<OrderEntry />} />;
  };
  const createNewRx = () => {
    return (
      <Route
        path="/workflow-orderEntry-createNewRx"
        element={<CreateNewRx />}
      />
    );
  };
  const addNewPatient = () => {
    return (
      <Route
        path="/workflow-orderEntry-addNewPatient"
        element={<AddNewPatient />}
      />
    );
  };

  const entryNewRxSearchPatients = () => {
    return (
      <Route
        path="/workflow-orderEntry-entryNewRxSearchPatients"
        element={<EntryNewRxSearchPatient />}
      />
    );
  };

  const addNewRxSearch = () => {
    return (
      <Route
        path="/workflow-orderEntry-addNewRxSearch"
        element={<AddNewRxSearchPatient />}
      />
    );
  };
  const patientdetails = () => {
    return (
      <Route
        path="/workflow-orderEntry/patient-details/:id"
        element={<PatientDetails />}
      />
    );
  };
  const claims = () => {
    return <Route path="/workflow-claims" element={<Claims />} />;
  };
  const initial = () => {
    return <Route path="/workflow-initial" element={<InitialReviewPage />} />;
  };
  const packaging = () => {
    return <Route path="/workflow-packaging" element={<Packaging />} />;
  };
  const pending = () => {
    return <Route path="/workflow-pending" element={<Pending />} />;
  };
  const final = () => {
    return <Route path="/workflow-final" element={<FinalReviewPage />} />;
  };

  const InitialPatientDetails = () => {
    return (
      <Route
        path="/workflow-initial-patient-details/:id"
        element={<InitialReviewPatientDetails />}
      />
    );
  };

  const InitialPatientEditDeatils = () => {
    return (
      <Route
        path="/patient-edit-detials"
        Component={<InitialPatientEditDetails />}
      />
    );
  };

  const FinalDetails = () => {
    return (
      <Route
        path="/workflow-final-review-details/:id"
        element={<FinalReviewDetailsPage />}
      />
    );
  };
  const packagingInfoDetails = () => {
    return (
      <Route
        path="/workflow-packaging-info-Details/:id"
        element={<PackagingInfoDetails />}
      />
    );
  };

  const InventoryDashBoard = () => {
    return <Route path="/inventory-dashboard" element={<InvDashboard />} />;
  };

  const Optimization = () => {
    return (
      <Route path="/inventory-optimization" element={<InvOptimization />} />
    );
  };

  const InvProducts = () => {
    return <Route path="/inventory-products" element={<Products />} />;
  };

  const InvCycleCount = () => {
    return <Route path="/inventory-cyclecount" element={<CycleCount />} />;
  };

  const InvPurchaseOrders = () => {
    return (
      <Route
        path="/inventory-purchase-order/:tab"
        element={<PurchaseOrders />}
      />
    );
  };
  const OnOrderQueue = () => {
    return <Route path="/on-order-queue" element={<OnOrderQueue />} />;
  };
  const OnOrderQueueDetail = () => {
    return (
      <Route
        path="/inventory-purchase-order/on-order-queue-details/:id"
        element={<OnOrderQueueDetails />}
      />
    );
  };

  const OnOrderDetail = () => {
    return (
      <Route
        path="/inventory-purchase-order/order-history/:id"
        element={<OrdersDetails />}
      />
    );
  };
  const OrderReceiveDetails = () => {
    return (
      <Route
        path="/inventory-purchase-order/order-receive-details/:id"
        element={<ReceiveOrderDetails />}
      />
    );
  };

  const patientslink = () => {
    return <Route path="/workflow-patients" element={<PatientsPage />} />;
  };

  const ReportDashboard = () => {
    return <Route path="/reports-dashboard" element={<ReportsDashboard />} />;
  };

  const ReportSchduler = () => {
    return <Route path="/reports-schduler" element={<ReportsSchduler />} />;
  };

  const PatientInfo = () => {
    return (
      <Route
        path="/workflow-patients-Patient-info/:id"
        element={<PatientInformation />}
      />
    );
  };

  const ReportsBuilder = () => {
    return <Route path="/reports-builder" element={<Builder />} />;
  };

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Outlet />}>
            <Route element={<PrivateRoute modules={modules} />}>
              {/* {renderPurchaseOrder()} */}
              {dashboard()}
              {renderLogin()}
              {orderEntry()}
              {claims()}
              {initial()}
              {packaging()}
              {pending()}
              {final()}
              {entryNewRxSearchPatients()}
              {createNewRx()}
              {addNewPatient()}
              {patientdetails()}
              {InitialPatientDetails()}
              {InitialPatientEditDeatils()}
              {FinalDetails()}
              {packagingInfoDetails()}
              {InventoryDashBoard()}
              {Optimization()}
              {InvProducts()}
              {InvCycleCount()}
              {InvPurchaseOrders()}
              {OnOrderQueue()}
              {OnOrderQueueDetail()}
              {OnOrderDetail()}
              {OrderReceiveDetails()}
              {patientslink()}
              {ReportDashboard()}
              {ReportSchduler()}
              {PatientInfo()}
              {ReportsBuilder()}
              {addNewRxSearch()}
            </Route>

            {/* catch all */}
            <Route path="*" element={<NotValidTab />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

export default App;
